import React, { useState, useCallback } from 'react';
import './TabPanel.css';
import { Icon, IconButton } from '@castandcrew/platform-ui';

const TabPanel = ({ tabs, activeTab, onTabChange, onTabClose, onTabAdd }) => {
  const [draggedTab, setDraggedTab] = useState(null);
  const [dragOverTab, setDragOverTab] = useState(null);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const handleTabClick = tabId => {
    onTabChange(tabId);
  };

  const handleTabClose = (e, tabId) => {
    e.stopPropagation();
    onTabClose(tabId);
  };

  const handleDragStart = (e, tabId) => {
    setDraggedTab(tabId);
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleDragOver = (e, tabId) => {
    e.preventDefault();
    setDragOverTab(tabId);
  };

  const handleDrop = (e, targetTabId) => {
    e.preventDefault();
    if (draggedTab && draggedTab !== targetTabId) {
      // Handle tab reordering here if needed
      console.log(`Move tab ${draggedTab} to position of ${targetTabId}`);
    }
    setDraggedTab(null);
    setDragOverTab(null);
  };

  const toggleFullscreen = () => {
    setIsFullscreen(!isFullscreen);
  };

  return (
    <div className={`tab-panel ${isFullscreen ? 'fullscreen' : ''}`}>
      <div className="tab-header">
        <div className="tabs-container">
          {tabs.map(tab => (
            <div
              key={tab.id}
              className={`tab ${activeTab === tab.id ? 'active' : ''} ${
                dragOverTab === tab.id ? 'drag-over' : ''
              }`}
              onClick={() => handleTabClick(tab.id)}
              draggable
              onDragStart={e => handleDragStart(e, tab.id)}
              onDragOver={e => handleDragOver(e, tab.id)}
              onDrop={e => handleDrop(e, tab.id)}
              onDragLeave={() => setDragOverTab(null)}
            >
              <span className="tab-icon">{tab.icon}</span>
              <span className="tab-title">{tab.title}</span>
              {tabs.length > 1 && (
                <button
                  className="tab-close"
                  onClick={e => handleTabClose(e, tab.id)}
                  title="Close tab"
                >
                  ×
                </button>
              )}
            </div>
          ))}
        </div>
        <div className="tabs-expander">
          <IconButton
            buttonVariant="ghost"
            iconName={isFullscreen ? 'minimize' : 'maximize'}
            size="md"
            onPress={toggleFullscreen}
            title={isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'}
          />
        </div>
      </div>

      <div className={`tab-content ${isFullscreen ? 'fullscreen' : ''}`}>
        {tabs.map(tab => (
          <div key={tab.id} className={`tab-pane ${activeTab === tab.id ? 'active' : ''}`}>
            {tab.content}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TabPanel;
